import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import createHistory from 'history/createHashHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';

import ordersReducer from '../reducers/ordersReducer';

export const history = createHistory();

const middleware = routerMiddleware(history);

const reducer = combineReducers({
  router: routerReducer,
  order: ordersReducer,
});

export const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  compose(applyMiddleware(middleware, thunk)),
);



// WEBPACK FOOTER //
// src/redux/store/configureStore.js